import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum OpportunityMasterServicesStatusIds {
  NO_SERVICES = 1,
  IN_PROGRESS = 2,
  BIDS_NEEDED = 3,
  RFQS_SENT = 4,
  BIDS_RCVD = 5,
  BIDS_SELECTED = 6,
  READY_FOR_CONTRACT = 7,
  SOME_CLOSED = 8,
  SOME_CLOSED_WON = 9,
  CLOSED = 10,
  CLOSED_WON = 11,
  REOPENED = 12,
  REOPENED_SOME_CLOSED_WON = 13,
  REOPENED_SOME_CLOSED = 14,
  NOT_SET = 15,
}

export function getOpportunityMasterServicesStatii(): ISelectItem[] {
  return [
    {
      id: OpportunityMasterServicesStatusIds.NO_SERVICES,
      label: 'No Services',
      disabled: true,
    },
    {
      id: OpportunityMasterServicesStatusIds.IN_PROGRESS,
      label: 'In Progress',
    },
    {
      id: OpportunityMasterServicesStatusIds.BIDS_NEEDED,
      label: 'Bids Needed',
    },
    { id: OpportunityMasterServicesStatusIds.RFQS_SENT, label: 'RFQs Sent' },
    { id: OpportunityMasterServicesStatusIds.BIDS_RCVD, label: 'Bids Rcvd' },
    {
      id: OpportunityMasterServicesStatusIds.BIDS_SELECTED,
      label: 'Bids Selected',
    },
    {
      id: OpportunityMasterServicesStatusIds.READY_FOR_CONTRACT,
      label: 'Ready for Contract',
    },
    {
      id: OpportunityMasterServicesStatusIds.SOME_CLOSED,
      label: 'Some Closed',
      disabled: true,
    },
    {
      id: OpportunityMasterServicesStatusIds.SOME_CLOSED_WON,
      label: 'Some\nClsd Won',
      disabled: true,
    },
    {
      id: OpportunityMasterServicesStatusIds.CLOSED,
      label: 'Closed',
      disabled: true,
    },
    {
      id: OpportunityMasterServicesStatusIds.CLOSED_WON,
      label: 'CLOSED WON',
      disabled: true,
    },
    {
      id: OpportunityMasterServicesStatusIds.REOPENED,
      label: 'Reopened',
      disabled: true,
    },
    {
      id: OpportunityMasterServicesStatusIds.REOPENED_SOME_CLOSED_WON,
      label: 'Reopened Some Clsd Won',
      disabled: true,
    },
    {
      id: OpportunityMasterServicesStatusIds.REOPENED_SOME_CLOSED,
      label: 'Reopened Some Clsd',
      disabled: true,
    },
    {
      id: OpportunityMasterServicesStatusIds.NOT_SET,
      label: 'Not Set',
      disabled: true,
    },
  ]
}

export const getOpportunityMasterServiceStatusByLabel = getItemByLabelFactory(
  getOpportunityMasterServicesStatii
)
export const getOpportunityMasterServiceStatusById = getItemByIdFactory(
  getOpportunityMasterServicesStatii
)
